export const constants = {
	//Grant Permissions
	ENTITY_TYPE_ID_PERSON: 4,
	ENTITY_TYPE_ID_TEAM: 5,
	ENTITY_TYPE_ID_ASSETDEVICE: 6,
	ENTITY_TYPE_ID_ASSETGROUP: 7,
	//Asset Group Types
	GENERAL: 1,
	ACCESS_CONTROL: 2,
	INNER_RANGE: 3,
	//Default Category
	/*
	 * List of default categories
	 */
	HEALTH_SAFETY: 1,
	SMART_LOCKS: 12,
	SMART_GATEWAYS: 13,
	SMART_LOCKER: 14,
	VERKADA_CAMERAS: 15,
	VORTEX_CAMERAS: 23,
	// Camera device categories (Verkada + Vortex). Cameras are NOT a grantable
	// resource — visibility follows the viewer's site admin scope, not a permission
	// row. Used for display/filtering only. See library/helpers/deviceFamily.isCamera.
	CAMERA_CATEGORIES: [15, 23],
	/*
	 * How each camera vendor's name is WRITTEN. The server sends `provider` as a bare key
	 * ('verkada', 'vortex') and every surface that shows it has to capitalise it the same
	 * way — VORTEX is not "Vortex".
	 *
	 * ⚠️ It is also the ALLOWLIST for the provider key interpolated into the sync URL
	 * (see Redux/cameras/saga.js). Adding a key here makes `/{provider}/sync` reachable for
	 * it, so add one only alongside a provider the server actually serves.
	 */
	CAMERA_PROVIDER_LABELS: { verkada: 'Verkada', vortex: 'VORTEX' },
	ZEZAMII_ACCESS: 17,
	ZEZAMII_GATEWAYS: 18,
	ZEZAMII_LOCKERS: 19,
	ADD_DEVICE_EXCLUDED_CATEGORIES: [12, 13, 14, 17, 18, 19, 20, 21, 22],
	ACCESS_CONTROL_CATEGORIES: [12, 17],
	SMART_CATEGORIES: [12, 13, 14, 17, 18, 19],
	NON_EDITABLE_SMART_CATEGORIES: [12, 13, 17, 18],
	BOOKEABLE_LOCKERS: [14, 19],
	INNER_RANGE_DOORS: 20,
	INNER_RANGE_LIFTS: 21,
	INNER_RANGE_LIFTS_FLOORS: 22,
	INCEPTION_DOORS: 24,
	INCEPTION_AREAS: 25,
	INCEPTION_LIFTS_FLOORS: 26,

	//These categies as consideted as gateways for permissions, credentials and actions management
	GATEWAY_CATEGORIES: [13, 18],

	// These categories are considered as inner range devices for permissions, credentials and actions management
	INNER_RANGE_DEVICE_CATEGORIES: [20, 21, 22],

	// Inception access-granting categories — doors (24) + lift floors (26). Areas (25) are excluded:
	// an area is armed/disarmed, not unlocked, so it is not a door-style access/permission target.
	INCEPTION_DEVICE_CATEGORIES: [24, 26],

	// Access Control System (ACS) devices — reader/controller-based access points across
	// providers (Inner Range 20/21/22 + Inception 24/25/26). Distinct from standalone smart
	// Locks (CONTROL_DEVICE_CATEGORIES). Add new ACS provider categories (e.g. Akuvox) here.
	ACS_DEVICE_CATEGORIES: [20, 21, 22, 24, 25, 26],

	// These categories are considered as control devices for permission, credential and action management
	CONTROL_DEVICE_CATEGORIES: [12, 14, 17, 19],

	/*
	 * Permission Manageable Categories
	 * These categories allow permission management for devices and device groups.
	 * Used for filtering which devices/groups can have permissions assigned.
	 */
	PERMISSION_MANAGEABLE_CATEGORIES: [12, 17, 20, 21, 22],

	/*
	 * Smart Categories
	 * These categories are considered as smart categories. (locker, lock, gateway)
	 * Smart categories cannot modify the additional fields by user.
	 */
	ACTIONABLE_SMART_LOCKS: [12, 14, 17, 19],
	/*
	 * Actionable Smart Locks
	 * These category will show the action for unlock or lock the smart categories (locker, lock, gateway)
	 */

	UNLOCK_CATEGORIES: [12, 14, 17, 19, 20, 21],

	// All device categories (locks, gateways, lockers, cameras, IR devices).
	// Excludes non-device categories like Health & Safety (1).
	DEVICE_CATEGORIES: [12, 13, 14, 15, 17, 18, 19, 20, 21, 22, 23],

	VIDEO_FIELD_TYPE_ID: 5
};
